<template>
  <div id="attributes" v-if="loadPage">
    <div class="centerx">
      <div class="vx-card">
        <div class="vx-card__body">
          <form v-if="!loading">
            <div class="vx-row  mb-6">
              <div class="vx-col lg:w-1/3 w-full mb-2">
                <vs-input
                  class="inputx mb-4 mt-1"
                  :placeholder="$t('PersianName')"
                  :value="genericProduct.name"
                  @input="e => updateField('name', e)"
                  name="persianName"
                  :label="$t('PersianName')"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('persianName')"
                  >{{ errors.first("persianName") }}</span
                >
              </div>
              <div
                class="vx-col sm:w-1/3 w-full mb-2 mt-1"
                v-if="!loading && allCategories && genericProduct.categoryId"
              >
                <label class="vs-select--label">{{ $t("Department") }}</label>
                <v-select
                  label="name"
                  name="cat"
                  :options="allCategories"
                  :reduce="x => x.id"
                  :value="
                    allCategories.filter(
                      x => x.id == genericProduct.categoryId
                    )[0].name
                  "
                  @input="e => updateField('categoryId', e)"
                  v-validate="{ required: true }"
                  dir="rtl"
                >
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('cat')">{{
                  errors.first("cat")
                }}</span>
              </div>
              <div class="vx-col lg:w-1/3 mt-10  w-full mb-2">
                <vs-checkbox
                  :value="genericProduct.isActive"
                  @input="e => updateField('isActive', e)"
                >
                  {{ $t("Active") }}
                </vs-checkbox>
              </div>
            </div>
          </form>
          <div class="vx-card">
            <div class="vx-card__body">
              <vs-tabs vs-alignment="fixed" alignment="fixed">
                <vs-tab
                  :label="$t('CreateAndManageGroupsAndAttributes')"
                  class="mt-2"
                >
                  <groups-and-attributes></groups-and-attributes>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";
import GroupsAndAttributes from "./GroupsAndAttributes.vue";

const dict = {
  custom: {
    persianName: {
      required: "لطفا نام فارسی را وارد نمایید."
    },
    cat: {
      required: "لطفا دپارتمان را انتخاب نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      loadPage: false
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    GroupsAndAttributes
  },
  computed: {
    ...mapGetters({
      allCategories: "category/list",
      genericProduct: "genericProduct/details",
      loading: "genericProduct/loading"
    })
  },
  mounted() {
    this.fetchCategories();
    this.load();
    setTimeout(() => {
      this.loadPage = true;
    }, 500);
  },
  methods: {
    ...mapActions({
      fetchGenericProduct: "genericProduct/fetchSingle",
      fetchCategories: "category/fetch"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchGenericProduct(id);
    },
    updateField(field, value) {
      this.$store.commit("genericProduct/setDetailsFields", { field, value });
    }
  }
};
</script>
